import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { ConfigurationSelectors } from './configuration.selectors';
import { ConfigurationActions } from './configuration.actions';

@Injectable({ providedIn: 'root' })
export class ConfigurationStore {
  constructor(private store: Store) {}

  selectFeaturesBaseUri$ = this.store.select(ConfigurationSelectors.selectFeaturesBaseUri);

  useClimateSolutionsDomain(): void {
    this.store.dispatch(ConfigurationActions.useClimateSolutionsDomain());
  }
}
